import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable({ providedIn: 'root' })
export class GlobalMessageService {
  constructor(private messageService: MessageService) {}

  showSuccess(summary: string, detail: string, duration?: number) {
    this.messageService.add({
      severity: 'success',
      summary,
      detail,
      life: duration || 3000,
    });
  }

  showError(summary: string, detail: string, duration?: number) {
    this.messageService.add({
      severity: 'error',
      summary,
      detail,
      life: duration || 5000,
    });
  }

  showInfo(summary: string, detail: string, duration?: number) {
    this.messageService.add({
      severity: 'info',
      summary,
      detail,
      ...(duration ? { life: duration } : {}),
    });
  }

  showWarn(summary: string, detail: string, duration?: number) {
    this.messageService.add({
      severity: 'warn',
      summary,
      detail,
      ...(duration ? { life: duration } : {}),
    });
  }
}
